import React from "react";
import { Link } from "react-router-dom";

import "../../assets/common/css/dashboarButton.css";

function Dashboard() {
  const coachDashboardButtons = [
    {
      name: "出席状況",
      path: "/coach/attendance",
      icon: "fas fa-tachometer-alt",
    },
  ];

  return (
    <div className="p-3">
      <p className="headline">コーチ機能一覧です</p>
      <div className="btn-container col-md-4 col-sm-12">
        {coachDashboardButtons.map(button => (
          <Link to={button.path}>
            <button className="dash-btn">{button.name}</button>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
